module.exports = __webpack_public_path__ + "img/CW_Robert_Ellis+Meshell-4066.63556763.jpg";